import QueryParams from '@linc-technologies/linced-common/helpers/query-params';

// register query-params helper for embroider static analysis and bundling.
export function initialize(application) {
  application.register('helper:query-params', QueryParams);
}

export default {
  name: 'query-params-helper',
  initialize,
};
